module.exports = __webpack_public_path__ + "static/media/S4N6-4.67431341.svg";